import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CartItem from '../../components/CartItem';
import OrderSummary from '../../components/OrderSummary';
import './CartPage.css';
import { useCart } from '../../contexts/CartContext';
import { useDealership } from '../../contexts/DealershipContext';
import { useEmployees } from '../../contexts/EmployeeContext';

const CartPage = () => {
  const {
    lineItems,
    updateQuantity,
    removeFromCart
  } = useCart();
  const { dealership } = useDealership();
  const { employees, fetchEmployees } = useEmployees();

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Pagination options
  const pageSizeOptions = [5, 10, 20, 50];

  // Calculate pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = lineItems.slice(indexOfFirstItem, indexOfLastItem);

  // Calculate total pages
  const totalPages = Math.ceil(lineItems.length / itemsPerPage);

  // Handle page size change
  const handlePageSizeChange = (newPageSize) => {
    setItemsPerPage(newPageSize);
    setCurrentPage(1); // Reset to first page when changing page size
  };

  useEffect(() => {
    if (dealership?.bac) {
      fetchEmployees(dealership.bac);
    }
  }, [dealership?.bac, fetchEmployees]);

// Update internal state when cart items change
useEffect(() => {
  // side-effects could be added here if needed when lineItems update
}, [lineItems]);

useEffect(() => {
  if (Array.isArray(employees) && employees.length === 0) {
    // Handle empty employees list
  }
}, [employees]);


  return (
    <div className="cart-page-container">
      <div className="cart-page">
        <h1 className="cart-title">My Cart</h1>
        <div className="cart-content">
          <div className="cart-items-section">
            {/* A cart rarely needs paging — only offer it once it could matter */}
            {lineItems.length > 5 && (
              <div className="pagination-controls">
                <div className="page-size-selector">
                  <label>Items per page: </label>
                  <select
                    value={itemsPerPage}
                    onChange={(e) => handlePageSizeChange(Number(e.target.value))}
                  >
                    {pageSizeOptions.map(size => (
                      <option key={size} value={size}>
                        {size}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
            <div className="cart-items">
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <CartItem
                    key={indexOfFirstItem + index}
                    item={item}
                    index={indexOfFirstItem + index}
                    updateQuantity={updateQuantity}
                    removeFromCart={removeFromCart}
                    employees={employees}
                  />
                ))
              ) : (
                <div className="cart-empty-state">
                  <h2>Your cart is empty</h2>
                  <p>Build an ad or browse promotional items to get started.</p>
                  <div className="cart-empty-actions">
                    <Link to="/build-your-ad" className="btn btn-primary">Build Your Ad</Link>
                    <Link to="/promotions" className="btn btn-secondary">Browse Promotional Items</Link>
                  </div>
                </div>
              )}
            </div>
            {lineItems.length > itemsPerPage && (
              <div className="pagination">
                <button
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <span className="page-info">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            )}
          </div>
          {lineItems.length > 0 && (
            <OrderSummary
              cartItems={lineItems}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CartPage;
